import { useMutation } from '@tanstack/react-query';
import { BaseResponseType, apiClient } from 'shared/api';

const postLogout = async (): Promise<BaseResponseType<string>> => {
  const { data } = await apiClient.post('/auth/logout');
  return data;
};

export const usePostLogout = ({ onSuccess, onError }: { onSuccess: () => void; onError: () => void }) => {
  return useMutation({
    mutationFn: postLogout,

    onSuccess: () => {
      onSuccess();
    },
    onError: () => {
      onError();
    },
  });
};
